import React, { useEffect, useState } from 'react';
import { Icon } from '@synergy/icons';
import { Dropdown } from 'antd';
import i18next, { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
// import Logo_Synergy_IOC_White from '../../assets/img/Logo_Synergy_IOC_White.png';
import { useAuthContext } from '../../contexts/AuthContext';
import { usePageContentContext } from '../../contexts/PageContentProvider';
import logger from '../../server/server';
import { Avatar } from '../Global/Atomics/Avatar';
import { getTenantConfig } from '../../utils/config/tenantConfig';

//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const StyledHeader = styled.header`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    position: relative;
    height: 88px;
    min-height: 88px;
    max-width: inherit;
    border: 1px solid #DCE3E5;
    z-index: 2000;
`;

const HeaderFirstContent = styled.div`
    display: flex;
    align-items: center;
    height: 100%;

    > div{
        display: flex;
    }
`;

const HeaderFirstContentTabs = styled.div`
    /* margin-left: 104px; */
    height: 100%;
    display: flex;
    align-items: center;

    ul{
        /* width: max-content; */
        height: 100%;
        display: flex;
        align-items: center;
        padding: 0;
        margin: 0;

        li{
            display: flex;
            margin-right: 64px;
            height: 100%;
            align-items: center;
            color: #63666A;
            cursor: pointer;
        }
    }
`;

const HeaderSecondContent = styled.div`
    margin-right: 40px;
    display: flex;
    align-items: center;
    /* justify-content: space-around; */
    /* width: 534px; */
    /* height: 10vh; */
`;

const IconsOptionsContent = styled.div`
    /* width: 104px; */
    display: flex;
    /* justify-content: space-around; */
`;

const Image = styled.img`
    width: 240px;
    height: 70px;
    align-self: center;
    margin: 0 64px 0 64px;
`;

const Initials = styled.div`
    position: absolute;
    left: 17.5%;
    right: 17.5%;
    top: 25%;
    bottom: 25%;
    place-content: center;

    /* UI/XL medium */

    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 100%;
    /* identical to box height, or 20px */

    display: flex;
    align-items: center;
    text-align: center;

    /* Secondary/Blue/Blue 5 */

    color: #005587;
`;

const IconDropdown = styled.div`
    :hover{
        cursor: pointer;
    }
`;

//#endregion


export const Header = () => {
    //#region synergyComment: UseStates and UseEffects of the Header
    const { t } = useTranslation(); //the function t is used to translate the page
    const { user, tenant } = useAuthContext();
    const tenantConfig = getTenantConfig(); // Obter configuração do tenant baseado no URL
    //defines the zones array by empty when starting
    const [zones, setZones] = useState([]);
    //the token is something the profile of the user must be checked to enable the access to the page or not
    const { checkToken } = useAuthContext();
    //uses a funcation called usePageContentContext to handle the changes on the path of the page
    const { pagesConfiguration, handlePagePathChange, currentPath } = usePageContentContext();
    //defines headerData has an empty array to store the data from the header, and the function setHeaderData to update the state of headerData
    const [headerData, setHeaderData] = useState([]);

    const navigate = useNavigate();

    //is executed when initialized and checks if local store contains zones, if there are, they are stored in the state 'zones'
    useEffect(() => {
        try {
            const localStorageZones = localStorage.getItem('mico_zones');
            if (localStorageZones !== 'undefined') {
                const localStorageZonesParse = JSON.parse(localStorageZones);
                setZones(localStorageZonesParse);
            }
        } catch (error) {
            console.error('(Header page) Error getting zones from local storage:', error);
            //reportError(error); // Send error report to backend
            logger.error('(Header page) User: ' + user?.Username + " Tenant: " + tenant + " Error getting zones from local storage: ", error);
        }
    }, [])


    //this use effect works every time 'pagesConfiguration' changes and he maps pagesConfiguration to a specific format and then stores it in the headerData state
    useEffect(() => {
        try {
            if (pagesConfiguration) {
                const hd = [];
                pagesConfiguration.map(x => {
                    let hdObj = {
                        title: x.tabName,
                        icon: x.tabIcon,
                        id: x.id,
                        link: x.path,
                    };
                    hd.push(hdObj);
                });
                setHeaderData(hd);
            }
        } catch (error) {
            console.error('(Header page) Error page configuration:', error);
            //reportError(error); // Send error report to backend
            logger.error('(Header page) User: ' + user?.Username + " Tenant: " + tenant + " Error page configuration: ", error);
        }
    }, [pagesConfiguration])
    //defenition of function 'handlePath' that recives path as argument, executes the ´checkToken' function, and replaces the replaces the path on history using ´handlePagePathChange'
    function handlePath(path) {
        try {
            checkToken();
            navigate(path);
            handlePagePathChange(path)
        } catch (error) {
            console.error('(Header page) Error handling path:', error);
            //reportError(error); // Send error report to backend
            logger.error('(Header page) User: ' + user?.Username + " Tenant: " + tenant + " Error handling path: ", error)
        }
    }
    //#endregion

    //In this return we can see the styled components being applied and the header component that renders elements depending the data stored in 'headerData' and 'zones' states. Maps the data oh 'headerDAta' to generate a list in the header of the page
    //he can also see the other section of the header that has other render components like globaldropdown, avatar based on user initials or image
    return (
        <StyledHeader>
            <HeaderFirstContent>
                <div>
                    <Image src={tenantConfig.headerLogo} alt={'Tenant Logo'} />
                </div>
                <HeaderFirstContentTabs>
                    <ul>
                        {headerData.map((val, key) => {
                            if (zones?.includes(val.id)) {
                                return (<li key={key} onClick={() => { handlePath(val.link) }} className={currentPath.includes(val.link) ? "menuListActive" : ''}>
                                    {val.icon ? <Icon icon={val.icon} iconsize='md' color='green-deloitte' /> : null}
                                    {t(val.title)}
                                </li>)
                            }
                        })}
                    </ul>
                </HeaderFirstContentTabs>
            </HeaderFirstContent>
            <HeaderSecondContent>
                {/* <SearchBar /> */}
                <IconsOptionsContent>
                    {/* <Favorites /> */}
                    <GlobalDropdown />
                </IconsOptionsContent>
                <AvatarInitals />
            </HeaderSecondContent>
        </StyledHeader>
    )
}

//this component renders a global dropdown that allows the user to select the page language, it uses an object 'lngs' to store the available languages
//then it maps the languages from the lngs object to create a list of items in the dropdown, clicking one of these items the 'i18next.changeLanguage' function is called to change the page language
const GlobalDropdown = () => {
    const lngs = {
        en: { nativeName: 'English' },
        pt: { nativeName: 'Portugues' },
        it: { nativeName: 'Italiano' },
    }

    const items = Object.keys(lngs).map((lng, index) => (
        {
            label: <p onClick={() => i18next.changeLanguage(lng)} style={i18next.resolvedLanguage === lng ? { fontWeight: 'bold' } : null}>{lngs[lng].nativeName}</p>,
            key: index,
        }
    ));
    //the dropdown is triggered by the 'IconDropdown' component and is rendered using the dropdown from Ant Design
    return (
        <div id='header-dropdown' style={{ margin: '0px 12px 0px 12px' }}>
            <Dropdown menu={{ items }} trigger={['click']} getPopupContainer={() => document.getElementById('header-dropdown')}>
                <IconDropdown onClick={(e) => e.preventDefault()}>
                    <Icon iconsize={'sm'} icon='Global' color={'teal-3'} />
                </IconDropdown>
            </Dropdown>
        </div>
    )
}

//this component renders an avatar, will be based on the user's initials, for now it´s 'JD'. Uses
const AvatarInitals = () => {
    const { logout } = useAuthContext();
    const handleLogout = () => {
        try {
            logout();
        } catch (error) {
            console.error('(Header page) Error handleling logout:', error);
            //reportError(error); // Send error report to backend
        }
    }
    // const initials = userData?.username?.slice(0, 2) ?? 'sy';
    const items = [
        {
            label: <p>{t('logout')}</p>,
            key: '0',
            onClick: () => handleLogout(),
        },
    ];

    return (
        <div id='header-dropdown' style={{ margin: '0px 0px 0px 40px' }}>
            <Dropdown menu={{ items }} trigger={['click']} getPopupContainer={() => document.getElementById('header-dropdown')}>
                <Avatar>
                    <Initials><Icon icon={'User'} fill='#0076A8' iconsize='md' color={'teal-5'} /></Initials>
                </Avatar>
            </Dropdown>
        </div>
    )
}

//#region DEPERCATED
const Favorites = () => {
    return (
        <div style={{ margin: '0px 12px 0px 12px' }}>
            <Icon icon={'Favorite'} fill='#0076A8' iconsize='md' color={'teal-3'} />
        </div>
    )
}
//#endregion
